module.exports = __webpack_public_path__ + "img/Life_logo.c80b595f.png";